/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { LegalEntityType } from '../types/utils';

export type CompanyID = string;

export class Company {
	id: CompanyID = ''

	legalEntityType: LegalEntityType = LegalEntityType.GMBH

	name: string = ''

	registrationNumber: string = ''

	representativeFirstName?: string

	representativeLastName?: string

	tradeRegister: string = ''

	constructor(obj?: any) {
		if (obj) {
			Object.assign(
				this,
				obj
			);
		}
	}
}